/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ConnectWorkspaceType*`'s.
 */
export type ConnectWorkspaceType = ConnectWorkspaceTypeLimited | ConnectWorkspaceTypeFull;

/**
 * All of the possible `ConnectWorkspaceActionType*`'s.
 */
export type ConnectWorkspaceActionType = ConnectWorkspaceActionUpdateType | ConnectWorkspaceActionUserInvite;

/**
 * The dev type of the Connect workspace.
 * @export
 */
export type ConnectWorkspaceTypeLimited = typeof CONNECT_WORKSPACE_TYPE_LIMITED;

/**
 * The prod type of the Connect workspace.
 * @export
 */
export type ConnectWorkspaceTypeFull = typeof CONNECT_WORKSPACE_TYPE_FULL;

/**
 * The update type of the Connect workspace.
 * @export
 */
export type ConnectWorkspaceActionUpdateType = typeof CONNECT_WORKSPACE_ACTION_UPDATE_TYPE;

/**
 * The user invite update type of the Connect workspace.
 * @export
 */
export type ConnectWorkspaceActionUserInvite = typeof CONNECT_WORKSPACE_ACTION_USER_INVITE;

/**
 * The dev type of the Connect workspace.
 * @export
 */
export const CONNECT_WORKSPACE_TYPE_LIMITED = `limited`;

/**
 * The prod type of the Connect workspace.
 * @export
 */
export const CONNECT_WORKSPACE_TYPE_FULL = `full`;

/**
 * The update type of the Connect workspace.
 * @export
 */
export const CONNECT_WORKSPACE_ACTION_UPDATE_TYPE = `updateType`;

/**
 * The user invite update type of the Connect workspace.
 * @export
 */
export const CONNECT_WORKSPACE_ACTION_USER_INVITE = `inviteUser`;
